<template>
    <a
        class="btn-whatsapp"
        target="_blank"
        @click.stop
        :href="link"
        v-if="link"
    >
        <slot>
            <span class="fa fa-whatsapp"></span>
        </slot>
    </a>
</template>
<script>
import { phoneDigits } from "../../helpers/phone";

export default {
    name: "btn-whatsapp",
    props: {
        number: String,
        text: String,
    },
    computed: {
        place: function () {
            return { ...this.$store.state.place };
        },
        // Digits including country code, derived from the canonical E.164 value
        // (falls back to the place country for legacy national numbers).
        digits() {
            return phoneDigits(this.number, this.place.country_code || "BR");
        },
        link() {
            if (this.place.name === "Captable") {
                return this.appLink;
            }
            let text = "";
            if (this.text) {
                text = "&text=" + encodeURIComponent(this.text);
            }
            return this.digits
                ? "https://api.whatsapp.com/send?phone=" + this.digits + text
                : false;
        },
        appLink() {
            let text = "";
            if (this.text) {
                text = "&text=" + encodeURIComponent(this.text);
            }
            return this.digits
                ? "whatsapp://send?phone=" + this.digits + text
                : false;
        },
    },
};
</script>
